import { HttpErrorResponse } from '@angular/common/http';
import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@devinforius/i-essentials';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { TreeSelect } from 'primeng/treeselect';
import { Service } from 'src/app/shared/models/iCourrier/service';
import { DropdownClassificationCode, FolderManagementDTO } from 'src/app/shared/interfaces';
import { ClassificationsService } from 'src/app/shared/services/classifications.service';
import * as _ from 'underscore';

@Component({
  selector: 'app-create-edit-binder-modal',
  templateUrl: './create-edit-binder-modal.component.html',
  styleUrls: ['./create-edit-binder-modal.component.scss'],
})
export class CreateEditBinderModalComponent implements OnInit, AfterContentInit {
  @ViewChild('treeSelectCreateEditBinder') treeSelectCreateEditBinder: TreeSelect;
  @Input() public servicesParentSingleSelection: Service[] = []; // list of services for choice
  @Input() public classementsLV: DropdownClassificationCode[] = []; // list of classificationCodes for choice
  @Input() public servicesFusionned: { label: string; value: number; parentId: number }[] = []; // list of fusionnedServices to find the label of the chosen service

  @Input() formDatasToSendBackToCreateBinder = null; // data to send if needed to create another binder right after the first one

  @Input() public preSelectedService: number; // Service in which to create binder : sent from parent caller
  @Input() public preSelectedClassificationCode: number; // Classification code in which to create binder : sent from parent caller

  @Output() closeCreateEditBinder: EventEmitter<{ reload?: boolean; form?: UntypedFormGroup; createdBinder?: FolderManagementDTO }> =
    new EventEmitter<{ reload?: boolean; form?: UntypedFormGroup; createdBinder?: FolderManagementDTO }>(); // emitter to tell parent caller that the modal has finished its job

  //Autres données liées au component lui-même
  public formCreateEditBinder = new UntypedFormGroup({
    serviceId: new UntypedFormControl(null, Validators.required),
    archive: new UntypedFormControl(false),
    description: new UntypedFormControl(null, Validators.required),
    classementId: new UntypedFormControl(null, Validators.required),
    localisation: new UntypedFormControl(null),
    remarques: new UntypedFormControl(null),

    accesRestreint: new UntypedFormControl(null),
    serviceIds: new UntypedFormControl(null),
    classementAffine: new UntypedFormControl(null),
  });
  public selectedOptionCreateEditBinder;
  public translationPlaceholderPTree = '';
  public binder = null;

  constructor(
    private translater: TranslateService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private classificationsService: ClassificationsService
  ) {}

  ngOnInit(): void {
    this.translationPlaceholderPTree = this.translater.translate('pleaseSelectAService');
  }

  ngAfterContentInit(): void {
    this.spinner.show();
    this.setDatasFromConfig();
  }

  setDatasFromConfig(): void {
    if (this.preSelectedService) {
      this.selectedOptionCreateEditBinder = _.first(this.servicesFusionned.filter((x) => x.value === this.preSelectedService));
      this.formCreateEditBinder.patchValue({ serviceId: this.preSelectedService });
    }
    if (this.preSelectedClassificationCode) {
      this.formCreateEditBinder.patchValue({ classementId: this.preSelectedClassificationCode });
    }

    if (this.formDatasToSendBackToCreateBinder) {
      //Si on est dans la création multiple de farde ou dans l'édition alors on va patcher des données
      this.setDatasForPatchValues();
    } else {
      this.spinner.hide();
    }
  }

  setDatasForPatchValues(): void {
    this.binder = this.formDatasToSendBackToCreateBinder;
    this.formCreateEditBinder.patchValue({
      serviceId: this.binder.serviceId ?? null,
      classementId: this.binder.classementId ?? null,
      localisation: this.binder.localisation ?? null,
    });
    //puis on va setter les données obligatoires pour l'affichage du service
    if (this.binder.serviceId) {
      this.selectedOptionCreateEditBinder = _.first(this.servicesFusionned.filter((x) => x.value === this.binder.serviceId));
    }
    this.spinner.hide();
  }

  select(event): void {
    this.formCreateEditBinder.patchValue({
      serviceId: event.node.value,
    });
  }

  createBinder(type: 'single' | 'multiple'): void {
    if (this.formCreateEditBinder.valid) {
      this.spinner.show();

      this.classificationsService.postFolder(this.formCreateEditBinder.value).subscribe({
        next: (createdBinder) => {
          this.toastr.success(this.translater.translate('classification.binderSuccessfullyCreated'));
          type === 'single' ? this.closeModalBinderCreateEdit(true, createdBinder) : this.resetForCreationMultipleBinders(createdBinder);
          this.spinner.hide();
        },
        error: (err: HttpErrorResponse) => {
          console.error('Impossible de créer la/les farde(s)', err);
          this.spinner.hide();
        },
      });
    } else {
      this.toastr.warning(this.translater.translate('classification.requiredFieldsNotFilled'));
    }
  }
  closeModalBinderCreateEdit(reload, createdBinder?: FolderManagementDTO): void {
    this.selectedOptionCreateEditBinder = null;
    const labelTreeHtml = document.querySelectorAll('.treeSelectCreateEditBinder .p-treeselect-label');
    labelTreeHtml.length > 0 ? (labelTreeHtml[0].innerHTML = this.translationPlaceholderPTree) : null;
    this.treeSelectCreateEditBinder.value = [];
    this.closeCreateEditBinder.emit({ reload: reload, createdBinder: createdBinder });
  }

  resetForCreationMultipleBinders(createdBinder?: FolderManagementDTO): void {
    this.closeCreateEditBinder.emit({
      form: Object.assign({}, this.formCreateEditBinder.value),
      createdBinder: createdBinder,
    });
  }
}
